<template>
  <div>
    <card class="card" :title="$t('assigned_users')">
      <div class="card__right-button">
        <div class="position-relative">
          <button class="btn btn-just-icon btn-outline-warning mr-3 tooltipBtn" @click="openAdd = true">
            <i class="fas fa-plus" />
          </button>
          <div class="tooltipCustom tooltipCustom--bottom">Assign new User</div>
        </div>
      </div>

      <div v-if="users && users.length > 0">
        <ul class="list-unstyled team-members">
          <li>
            <div class="row" v-for="(user, index) in users" :key="users.index">
              <div class="col-md-2 col-xl-1">
                <div class="avatar">
                  <img :src="getImage(user)" alt="Circle Image" class="rounded img-fluid" />
                </div>
              </div>
              <div class="col-md-5 col-xl-3">
                {{ user.data.first_name }} {{ user.data.last_name }}
                <br />
                <span :class="getStatusClass(user.data.allow_log_in)">
                  <small>{{ getStatus(user) }}</small>
                </span>
              </div>

              <div class="col-md-2 col-xl-1">
                <div class="position-relative d-inline-block">
                  <p-button type="danger" outline icon class="tooltipBtn" @click.native.prevent="openDeleteModal(user)">
                    <i class="fa fa-user-times" />
                  </p-button>
                  <div class="tooltipCustom tooltipCustom--bottom">Remove User</div>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>

      <div v-else>
        <p>{{ $t('this_company_does_not_have_any_users') }}</p>
      </div>
    </card>

    <ModalTemplate
      component-name="AddUserModal"
      action="addRoleToUser"
      button-component-name="CreateNewButton"
      :data="{
        header: $t('assign_new_user'),
        users: this.company_users,
        for_obj: role,
      }"
      @submit="addUsers($event)"
      :clicked="openAdd"
      @update:field="openAdd = false"
      :button_data="{
        name: $t('assign_new_user'),
      }"
    >
    </ModalTemplate>

    <ModalTemplate
      component-name="DeleteModal"
      button-component-name="DeleteButton"
      action="removeRoleFromUser"
      :data="{
        deletion_object_name: user_full_name,
        deletion_object_text: $t('this_user'),
        delete_button_title: 'Remove user',
        header: 'Remove user',
        placeholder: $t('remove'),
        confirmation_word: $t('remove'),
        delete_button_name: $t('remove'),
      }"
      :clicked="open_delete_modal"
      @update:field="open_delete_modal = false"
      @submit="removeUser()"
    >
    </ModalTemplate>
  </div>
</template>
<script>
import ModalTemplate from '../../../components/modals/ModalTemplate';
import axiosAuth from '../../../axiosMain';
export default {
  components: { ModalTemplate },
  props: {
    role: {
      type: Object,
    },
    company: {
      type: Object,
    },
  },
  data() {
    return {
      title: 'Team members',
      openAdd: false,
      open_delete_modal: false,
      company_users: null,
      users: null,
      user_full_name: '',
      user: null,
    };
  },
  mounted() {
    this.getUsersOfRole();
  },
  methods: {
    getStatusClass(status) {
      switch (status) {
        case 2:
          return 'text-muted';
        case 1:
          return 'text-success';
        case 0:
          return 'text-danger';
        default:
          return 'text-success';
      }
    },
    addUsers: function (event) {
      axiosAuth
        .patch('/users_roles/' + this.role.role_id, {
          users: event,
        })
        .then((response) => {
          this.users = response.data.data;
          this.$notify({
            type: 'success',
            title: this.$t('Successful'),
            text: this.$t('the_users_were_assigned'),
          });
        })
        .catch((errors) => {
          this.$notify({
            type: 'danger',
            title: this.$t('Error') + ' ' + errors.response.status,
            text: errors.response.data,
          });
        });
    },
    getImage(member) {
      return require('../../../assets/img/sidebar_img_vl.jpg');
    },
    getStatus(member) {
      return member.data.allow_log_in === 1 ? 'Active' : 'Deactivated';
    },
    openModalCreate() {
      this.openCreate = true;
    },
    updateListUsers: function (event) {
      this.members.push(event);
    },
    getUsersOfRole: function () {
      axiosAuth
        .post(
          '/users_roles/role/' + this.role.role_id,
          {
            company_id: this.company.company_id,
          },
          {
            headers: {
              Authorization: 'Bearer ' + this.$store.getters.token,
            },
          }
        )
        .then((response) => {
          this.users = response.data.data;
          this.getCompanyUsers();
        });
    },
    getCompanyUsers: function () {
      axiosAuth
        .get('/company_users/' + this.company.company_id, {
          headers: {
            Authorization: 'Bearer ' + this.$store.getters.token,
          },
        })
        .then((response) => {
          let result = [];
          let companyUsersWithData = response.data.data;
          for (let i = 0; i < companyUsersWithData.length; i++) {
            result.push(companyUsersWithData[i].data);
          }
          this.company_users = result;
        })
        .then((response) => {
          this.resetLoader();
        });
    },
    openDeleteModal(user) {
      this.user = user;
      this.open_delete_modal = true;
      this.user_full_name = user.data.first_name + ' ' + user.data.last_name;
    },
    removeFromUsersList: function (removeUser) {
      let result = this.users;
      this.users.forEach(function (user, index) {
        if (user.data.user_id === removeUser.data.user_id) {
          result.splice(index, 1);
        }
      });
      this.users = result;
    },
    removeUser: function () {
      axiosAuth
        .post(
          '/users_roles/delete',
          {
            user_id: this.user.data.user_id,
            role_id: this.role.role_id,
          },
          {
            headers: {
              Authorization: 'Bearer ' + this.$store.getters.token,
            },
          }
        )
        .then((response) => {
          this.removeFromUsersList(this.user);
          this.$notify({
            type: 'success',
            title: this.$t('Successful'),
            text: this.$t('the_user_was_removed'),
          });
        })
        .catch((errors) => {
          this.$notify({
            type: 'error',
            title: this.$t('Error') + ' ' + errors.response.status,
            text: errors.response.data[0],
          });
        });
    },
  },
};
</script>
<style></style>
